import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { baseURL, tenantId } from '../../config/api';
import useWebData from '../../hooks/useWebData';
import DOMPurify from "dompurify";
import useReservation from '../../hooks/useReservationData';

type Props = {
  visible: boolean;
  setVisible: (value: boolean) => void;
};

export default function TermsAndConditionsPopup({ visible, setVisible }: Props) { 
  const { branchId, vehicleClassId }: any = useReservation();
  const { webData }: any = useWebData();
  const [agreementData, setAgreementData] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    setIsLoading(true);
    fetch(`${baseURL}termsAndCondition/GetTermsAndCondition/${branchId}/${vehicleClassId}`, {
      headers: {
        'X-Tenant-ID': tenantId,
      }
    })
      .then(response => response.text())
      .then(data => {
        setAgreementData(data);
        setIsLoading(false);
      })
      .catch(error => {
        console.error(error);
        setIsLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div
        className={`fixed inset-0 bg-black bg-opacity-25 backdrop-blur-sm z-50 flex items-center justify-center ${visible ? "flex" : "hidden"
          }`}
      >
        <div className="relative w-[90%] sm:w-[80%] md:w-[60%] lg:w-[48rem] bg-white p-4 rounded-lg shadow-lg max-h-[90vh] overflow-y-auto">

          <button
            className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-xl"
            onClick={() => setVisible(false)}
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>

          <h1 className="text-lg md:text-xl font-semibold text-center text-gray-700 mb-3">
            Terms & Conditions
            <hr className="mt-2" />
          </h1>

          <div className="max-h-[350px] overflow-y-auto border rounded px-3 py-2 bg-gray-50">
            {isLoading ? (
              <div className="flex justify-center items-center h-[350px]">
                <p className="text-sm font-medium text-gray-500">Loading...</p>
              </div>
            ) : (
              <div
                className="text-sm text-gray-700"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(agreementData),
                }}
              />
            )}
          </div>


          <div className="flex justify-end mt-4">
            <button
              style={{
                background: webData?.websiteHeaderColor,
                borderColor: webData?.websiteHeaderColor,
                color: "white",
              }}
              className="px-4 py-1.5 rounded-md text-sm font-medium border hover:shadow-md transition"
              onClick={() => setVisible(false)}
            >
              Close
            </button>
          </div>
        </div>
      </div>

    </>
  );
}
